import type { RouteReloadOption } from "@/store/modules/theme/types/index";
import { useThemeStore } from "@/store/modules/theme/index";
import { removeToken } from "./token-util";

export function setRouteReload(option: RouteReloadOption | null) {
  return useThemeStore().setRouteReload(option);
}

const logoutUrl = `${
  process.env.VUE_APP_DOMAIN
}/sso-cross-api/router/relogout/yzczb?url=${encodeURIComponent(
  window.location.href
)}&relogin=false`;

/**
 * @description: 退出登录
 * @param {boolean} route
 * @param {string} from
 * @return {*}
 */
export function logout() {
  removeToken();
  window.location.href = logoutUrl;
  // if (route) {
  //   router.push({
  //     path: "/login",
  //     query: from ? { from } : void 0,
  //   });
  // } else {
  //   // 避免再次登录重复注册动态路由
  // }
}
